// extracted by mini-css-extract-plugin
export default {"NameImport":"DeleteImporterModal_NameImport__j3J78"};